/*
 * Author: Harper Yan
 * File Created: Thursday, 24-11-07 11:45 am
 * Last Modified: Monday, 25-07-14 06:18 pm, by Dw
 */

import { generatePaths } from '@/src/utils/url';

// 浏览器UA访问白名单
export const UA_EXP_WHITE_LIST = [
  /(?:BitKeep)/i,
  /bitget/i,
  /benfenapp/i,
  /openblockapp/i,
  /DeCard/i,
  /gate\.io/i,
];

export const SINGPASS_SUPPORTED_CHANNEL = [
  'BF',
  'GATE',
  'MATRIXPORT',
  'TEST',
  // doo
  'DECARD-FOMO',
  'APP', // decard app
  'COIN98',
];

export const IFRAME_SAME_SITE_NONE_CHANNEL = ['BG-CEX', 'TEST', 'GATE'];

const OPEN_API_WHITE_LIST_PAGE = [
  // ===== KYC
  '/card/scheme', // card/scheme
  '/card/scheme/*', // card/scheme
  '/card/scheme/**/*', // card/scheme
  '/verification/manual', // 精确匹配
  '/verification/singpass', // 精确匹配

  // Card
  '/card/detail', // 精确匹配

  // landing 页面
  '/',

  '/open-api-error',
];

const DECARD_OPENAPI_WHITE_LIST_PAGE = [
  // 实体卡
  '/apply-physical-card',
  '/apply-physical-card/*',
  '/card/management/change-card',
  '/card/management/atm',
  '/card/depoint',
  '/card/depoint/depoint-transactions',
  '/dvault/referral',
  '/dvault/referral-visa',
  '/dvault/referral/referral-history',
  '/card/rebate',
];

const basePath = process.env.NEXT_PUBLIC_PREFIX_PATH;

const prefixOpenApiWhiteListPage = (arr: string[]) => {
  const prefixLang = generatePaths(arr);

  return prefixLang.map((item) => `${basePath}${item}`).concat(prefixLang);
};

export const PREFIX_OPEN_API_WHITE_LIST_PAGE = prefixOpenApiWhiteListPage(
  OPEN_API_WHITE_LIST_PAGE,
).map((item) => (item === '/' ? item : item.replace(/\/$/, '')));

export const PREFIX_DECARD_WHITE_LIST_PAGE = prefixOpenApiWhiteListPage(
  DECARD_OPENAPI_WHITE_LIST_PAGE,
).map((item) => (item === '/' ? item : item.replace(/\/$/, '')));
